export default __webpack_public_path__ + "static/media/stadium.cbee9020.svg";